import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';

/**
 * Le backend répond toujours en HTTP 200.
 * - success: false + error non vide (jsonError) → exception serveur : convertie en HttpErrorResponse,
 *   l'utilisateur ne voit rien, l'erreur est signalée par ErrorDigest.
 * - success: false + error: '' → refus métier : laissé au next du composant, qui affiche message.
 */
export const backendErrorInterceptor: HttpInterceptorFn = (req, next) =>
	next(req).pipe(
		map((event) => {
			const body = event instanceof HttpResponse ? (event.body as any) : null;
			if (body?.success === false && typeof body.error === 'string' && body.error !== '') {
				throw new HttpErrorResponse({
					error: body,
					status: 200,
					statusText: 'Backend error',
					url: event instanceof HttpResponse ? (event.url ?? undefined) : undefined,
				});
			}
			return event;
		}),
	);